/*eslint-disable */

export default {
  updatePromptResponse(context, payload) {
    return new Promise((resolve, reject) => {
      try {
        context.commit("setChatbotPromptResponse", payload);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  },
  removePromptResponse(context) {
    return new Promise((resolve, reject) => {
      try {
        context.commit("removeChatbotPromptResponse");
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }
}